exports.innerAction = [
    {
        _id: '001',
        name: '系统内置行为',
        action_list: [
            {
                name: '隐藏',
                id: 'inner_001',
                template: 'SetInActive'
            },
            {
                name: '显示',
                id: 'inner_002',
                template: 'SetActive'
            },
            {
                name: '移动',
                id: 'inner_003',
                template: 'Move'
            },
            {
                name: '旋转',
                id: 'inner_004',
                template: 'Rotate'
            },
            {
                name: '缩放',
                id: 'inner_005',
                template: 'Scale'
            },
            {
                name: '高亮',
                id: 'inner_006',
                template: 'HighLightOn'
            },
            {
                name: '取消高亮',
                id: 'inner_007',
                template: 'HighLightOff'
            },
            {
                name: '播放动画',
                id: 'inner_008',
                template: 'PlayAnimation'
            }
        ]
    }
]